import {NgModule} from '@angular/core';

@NgModule({
})

/**
 * Since this module is empty, you don't actually need to import it anywhere.
 * It is included for consistency of design.
 * Since it is meant to include any dependencies for this service.
 * If the service is ever modified to have dependencies,
 * then it will be required.
 * So it is still a good idea to import it.
 */
export class MessageModule {
}
